"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElectroCatapult = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class ElectroCatapult extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ELECTRO_CATAPULT,
            tags: [Tags_1.Tags.BUILDING],
            cost: 17,
            productionBox: Units_1.Units.of({ energy: -1 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(8).max()),
            metadata: {
                cardNumber: '069',
                description: {
                    text: 'Oxygen must be 8% or less. Decrease your energy production 1 step.',
                    align: 'left',
                },
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 1 plant or 1 steel to gain 7 M€.', (eb) => {
                        eb.plants(1).slash().steel(1).startAction.megacredits(7);
                    }).br;
                    b.production((pb) => pb.minus().energy(1));
                }),
                victoryPoints: 1,
            },
        });
    }
    canPlay(player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1 && super.canPlay(player);
    }
    canAct(player) {
        return player.plants > 0 || player.steel > 0;
    }
    action(player) {
        if (player.plants > 0 && player.steel > 0) {
            return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Spend 1 plant to gain 7 M€', 'Spend plant', () => {
                player.plants--;
                player.megaCredits += 7;
                this.log(player, Resources_1.Resources.PLANTS);
                return undefined;
            }), new SelectOption_1.SelectOption('Spend 1 steel to gain 7 M€', 'Spend steel', () => {
                player.steel--;
                player.megaCredits += 7;
                this.log(player, Resources_1.Resources.STEEL);
                return undefined;
            }));
        }
        else if (player.plants > 0) {
            player.plants--;
            this.log(player, Resources_1.Resources.PLANTS);
            player.megaCredits += 7;
        }
        else if (player.steel > 0) {
            player.steel--;
            this.log(player, Resources_1.Resources.STEEL);
            player.megaCredits += 7;
        }
        return undefined;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
    log(player, resource) {
        player.game.log('${0} spent 1 ${1} to gain 7 M€', (b) => b.player(player).string(resource));
    }
}
exports.ElectroCatapult = ElectroCatapult;
//# sourceMappingURL=ElectroCatapult.js.map